module.exports = __webpack_public_path__ + "img/warn_07.f21e5e89.png";